import { Button } from '@/modules/ui/components/button/Button';

interface ChatExample {
  label: string;
  prompt: string;
}

// The Finlay agent's main tasks: creating a job, reading one job's pipeline or all of them, and what waits on the HM.
// Each fills the box, so the HM can finish the sentence or send it as it is.
const examplesFor = (recentJobTitle?: string): ChatExample[] => [
  {
    label: 'Create a job',
    prompt: "I'd like to create a job. Here's the description:\n\n",
  },
  ...(recentJobTitle
    ? [
        {
          label: `How's ${recentJobTitle} going?`,
          prompt: `How's the ${recentJobTitle} job going?`,
        },
      ]
    : []),
  {
    label: "How's my pipeline?",
    prompt: "How's my pipeline looking across my jobs?",
  },
  { label: 'What needs me?', prompt: "What's waiting on me right now?" },
];

interface ChatExamplesProps {
  /** Puts the example's opening in the message box. */
  onPick: (prompt: string) => void;
  /** The HM's newest active job, which an example asks about; without one that example is left out. */
  recentJobTitle?: string;
}

/** Example tasks under a new chat's box. */
export function ChatExamples({ onPick, recentJobTitle }: ChatExamplesProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {examplesFor(recentJobTitle).map(({ label, prompt }) => (
        <Button
          className="max-w-full"
          key={label}
          onClick={() => onPick(prompt)}
          size="sm"
          variant="outline"
        >
          <span className="truncate">{label}</span>
        </Button>
      ))}
    </div>
  );
}
